<template>
<div>
    <li
        v-if="Object.keys(items).length > 0"
        class="nav-item dropdown"
        @click="toggleDropDown"
        v-click-outside="closeDropDown">
        <a class="nav-link" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <i class="fas fa-th" :style="{color: color.secondary}"></i>
        </a>

        <div class="dropdown-menu dropdown-menu-lg dropdown-menu-dark"
            :style="[$bgColor(color.primary), {color: color.secondary}]"
            :class="[{show: isOpen}, {'dropdown-menu-right': direction}]">
            <div class="row shortcuts px-4">
                <NavbarMenuItem
                    v-for="item in items"
                    :key="item.name"
                    :href="item.href"
                    :name="$t(item.name)"
                    :icon="item.icon"
                    :color="item.color"
                    :dev="item.dev" />
            </div>
        </div>
    </li>
</div>

</template>

<script>
import NavbarMenuItem from './NavbarMenuItem'
export default {
    name: 'Menu',
    data() {
        return {
            isOpen: false
        }
    },
    props: {
        user: {
            type: Object | undefined,
            required: true
        },
        items: {
            type: Object|Array,
            required: true,
        }
    },
    components: {
        NavbarMenuItem
    },
    computed: {
        direction() {
            return !this.$store.getters.NAVBAR_POSITION
        },
        color() {
            return this.$store.getters.NAV_COLOR
        }
    },
    methods: {
        toggleDropDown() {
            this.isOpen = !this.isOpen
            this.$emit('change', this.isOpen)
        },
        closeDropDown() {
            this.isOpen = false;
            this.$emit('change', false)
        }
    }
}
</script>